import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { reactQueryKeys } from '@/config/react-query';

export const useOnCallEnded = () => {
  const queryClient = useQueryClient();

  const onCallEnded = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [reactQueryKeys.history] });
  }, [queryClient]);

  return onCallEnded;
};
